export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle strokeOpacity=".7" stroke="#FFF" strokeWidth="2" cx="24" cy="24" r="23" />
                <g transform="translate(18 17)" fill="#FFF">
                    <rect width="4" height="14.571" rx="2" />
                    <rect x="8" width="4" height="14.571" rx="2" />
                </g>
            </g>
        </svg>
    );
}
